module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAONJREFUOE/VU7ENwjAQvPcuDIEESzAEDUoBOyBRMwM7kA0QFCxBATRUNEjIh95OYscxyC2FFdnO392f72W0fpMC9JfACkEjyXn4zzY1kgNwlwXFNEAGQFkJqwBQoFSd31s9RxYAsOJBnIoMSCv/i4KWQQBlGvjT3IvSlygQYDcTLGri8SowMTBK1/9laXB/EvM9cbxFnqQmVlPjelZp8Xc1Vr2AJbE5ENtzaK33CtXE903xBS4bAIoB2jClOehaqInTNTK2NAdZE/8rB8Nh+/IKLuNd8kIOYoBeMnMmZufgxzx8ALEMKnho5vC5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/image/banban.png
// module id = WlT9
// module chunks = 1